import type { RedoIntegrationsRpcClient } from "@redotech/redo-merchant-integrations-rpc/client";
import { createRedoIntegrationsRpcClient } from "@redotech/redo-merchant-integrations-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoIntegrationsRpcClientContext: Context<
  RedoIntegrationsRpcClient | undefined
> = createContext<RedoIntegrationsRpcClient | undefined>(undefined);

RedoIntegrationsRpcClientContext.displayName =
  "RedoIntegrationsRpcClientContext";

export interface RedoIntegrationsRpcClientProviderProps {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}

export function RedoIntegrationsRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: RedoIntegrationsRpcClientProviderProps) {
  const client = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoIntegrationsRpcClient({
      baseURL: new URL(`${baseUrl}/integrations-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);

  return (
    <RedoIntegrationsRpcClientContext.Provider value={client}>
      {children}
    </RedoIntegrationsRpcClientContext.Provider>
  );
}
